import { Spin } from "@/components/ui-feat/spin";
import { useGullakCashHistory } from "../../hooks/useGullakCashHistory";
import { useTranslations } from 'next-intl';
import CashHistoryList from "./CashHistoryList";
import Empty from '@/components/ui-feat/empty';

interface HistoryTabProps {
  visible: boolean;
  operate: string;
}

export default function HistoryTab({ visible, operate }: HistoryTabProps) {
  const t_common = useTranslations('common');

  const {
    data: historyList,
    hasMore,
    scrollRef,
    isInitLoading,
    isEmpty,
    isLoadingMore,
  } = useGullakCashHistory({
    operate,
    visible,
    pageSize: 20,
  });

  return (
    <div className="h-full flex flex-col">
      {isInitLoading && (
        <div className="flex-1 flex items-center justify-center">
          <Spin />
        </div>
      )}

      {isEmpty && (
        <div className="flex-1 flex items-center justify-center">
          <Empty />
        </div>
      )}

      {!isInitLoading && !isEmpty && (
        <div
          ref={scrollRef}
          className="flex-1 overflow-y-auto overflow-x-hidden rounded-lg"
        >
          <CashHistoryList data={historyList} />

          <div className="py-8 text-center">
            {isLoadingMore ? (
              <div className="flex items-center justify-center gap-2 text-tertiary text-xs">
                {t_common('loading')}
              </div>
            ) : !hasMore ? (
              <div className="text-tertiary text-xs">{t_common('noMoreData')}</div>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
}
